module.exports = __webpack_public_path__ + "static/media/timelapse_23.f087e5f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_23.jpg
// module id = 981
// module chunks = 0